import React, { useCallback } from "react";
import Icons from "../../../../Config/Images";
import "./EmptyCart.css";
import { useNavigate } from "react-router-dom";
const EmptyCart = () => {
  const navigate = useNavigate();
  const handleButtonNavigation = useCallback(() => {
    navigate("/home");
  }, []);
  return (
    <>
      <div className="EmptyCartDiv">
        <div className="text-content">
          <h3>Your cart is empty.</h3>
          <p>Let's fill it up with some amazing jewellery!</p>
        </div>
        <img src={Icons.emptyCartImage} alt="" />
        <div className="button-shopping">
          <button onClick={handleButtonNavigation}>Explore now</button>
        </div>
      </div>
    </>
  );
};

export default EmptyCart;
